export default "__VITE_ASSET__BqUdT5uz__"